import has from 'lodash/has';
import isNil from 'lodash/isNil';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions';
import { ROUTE_SSO_AUTH_LINK, ROUTE_SSO_LOGIN } from '../../constants/pathnames';
import { getCurrentUser } from '../../reducers/session';

export default function PublicRoute({ path, component: Component }) {
  const dispatch = useDispatch();
  const currentPath = useSelector((state) => state.routes.currentPath);
  const currentUser = useSelector(getCurrentUser);
  const gApiLoadStatus = useSelector((state) => state.session.googleAuth.loadStatus);
  const userLoggedIn = currentUser ? true : false;

  const { setCurrentPath } = bindActionCreators(
    { setCurrentPath: actions.setCurrentPath },
    dispatch,
  );

  function _setNewPath(newPath) {
    setTimeout(() => {
      setCurrentPath(newPath);
    }, 0);
  }

  return (
    <Route
      path={path}
      render={(props) => {
        if (props.match && props.match.isExact && currentPath !== props.location.pathname) {
          _setNewPath(props.location.pathname);
        }

        const isSSOLoginRoute = path === ROUTE_SSO_LOGIN ? true : false;

        const isSSOLoadingRoute = path === ROUTE_SSO_AUTH_LINK ? true : false;

        if (isSSOLoginRoute || isSSOLoadingRoute) {
          return <Component userLoggedIn={userLoggedIn} {...props} />;
        } else if (userLoggedIn) {
          let from = { pathname: '/' };

          if (!isNil(props.location.state) && has(props.location.state, 'from')) {
            from = props.location.state.from;
          }
          return <Redirect to={from} />;
        } else {
          return (
            <Component userLoggedIn={userLoggedIn} gApiLoadStatus={gApiLoadStatus} {...props} />
          );
        }
      }}
    />
  );
}
